import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';

export function createAppliedLessonsFilter(companySetting, display_default = false): AppliedLessonsFilter {
    const columns: AppliedLessonsFilter = {
        toDo: {
            visible: true,
            key: 'keywords.reports',
            display_default,
            display: false,
        },
        responsible: {
            visible: true,
            key: 'keywords.responsible',
            display_default,
            display: false,
        },
        contacttill: {
            visible: true,
            key: 'keywords.contacttill',
            display_default,
            display: false,
        },
        solution: {
            visible: true,
            key: 'keywords.solution',
            display_default,
            display: false,
        },
        dynamic_field: {
            visible: false,
            key: 'keywords.dynamic_field',
            title: '',
            display_default,
            display: false,
        },
        impact: {
            visible: false,
            key: 'keywords.impact',
            display_default,
            display: false,
            additionalFields: ['cost', 'probability'],
        },
        checked: {
            visible: true,
            key: 'keywords.check',
            display_default,
            display: false,
            additionalFields: ['checked_by_user', 'needscheck'],
        },
    };

    if (companySetting && companySetting.feature_dynamic_worksheet_field) {
        columns.dynamic_field.visible = true;
        columns.dynamic_field.title = companySetting.dynamic_worksheet_field_name;
    }

    if (companySetting && companySetting.feature_dynamic_worksheet_field_impact) {
        columns.impact.visible = true;
    }

    for (const [key] of Object.entries(columns)) {
        columns[key].display = columns[key].display_default;
    }

    return columns;
}
